import { render } from "./CrudPeriodoActivo.vue?vue&type=template&id=0fa39fb4"
import script from "./CrudPeriodoActivo.vue?vue&type=script&lang=js"
export * from "./CrudPeriodoActivo.vue?vue&type=script&lang=js"

import "./CrudPeriodoActivo.vue?vue&type=style&index=0&id=0fa39fb4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__